document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
    const href = a.getAttribute('href');
    if (!href || href.length < 2) return;
    const target = document.querySelector(href);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }));

  document.querySelectorAll('[data-transform-slider]').forEach(slider => {
    const track = slider.querySelector('[data-transform-track]');
    const area = slider.closest('.transform-area-v1');
    if (!track || !area) return;

    const slides = [...track.querySelectorAll('.transform-slide-v1')];
    const prev = area.querySelector('[data-transform-prev]');
    const next = area.querySelector('[data-transform-next]');
    const dots = [...area.querySelectorAll('[data-transform-dot]')];
    let index = 0;
    let settleTimer = 0;

    const updateDots = () => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    const syncDotsToPosition = () => {
      if (!slides.length || !slider.clientWidth) return;
      index = Math.max(0, Math.min(
        Math.round(slider.scrollLeft / slider.clientWidth),
        slides.length - 1
      ));
      updateDots();
    };

    const go = (newIndex, behavior = 'smooth') => {
      if (!slides.length) return;
      index = ((newIndex % slides.length) + slides.length) % slides.length;
      clearTimeout(settleTimer);
      slider.scrollTo({ left: index * slider.clientWidth, behavior });
      updateDots();
    };

    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));

    slider.addEventListener('scroll', () => {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(syncDotsToPosition, 120);
    }, { passive: true });

    slider.addEventListener('scrollend', syncDotsToPosition);
    window.addEventListener('resize', () => go(index, 'auto'));

    go(0, 'auto');
  });

  document.querySelectorAll('[data-preview-slider]').forEach(slider => {
    const track = slider.querySelector('[data-preview-track]');
    const area = slider.closest('.preview-single-wrap');
    if (!track || !area) return;

    const slides = [...track.querySelectorAll('.preview-single-slide')];
    const prev = area.querySelector('[data-preview-prev]');
    const next = area.querySelector('[data-preview-next]');
    const dots = [...area.querySelectorAll('[data-preview-dot]')];
    let index = 0;

    const updateDots = () => {
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    };

    const go = (newIndex, behavior = 'smooth') => {
      if (!slides.length) return;
      index = Math.max(0, Math.min(newIndex, slides.length - 1));
      slider.scrollTo({ left: slides[index].offsetLeft, behavior });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
      updateDots();
    };

    prev?.addEventListener('click', () => go(index - 1));
    next?.addEventListener('click', () => go(index + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));

    let raf = 0;
    slider.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        let best = 0;
        let bestDistance = Infinity;
        slides.forEach((slide, i) => {
          const distance = Math.abs(slide.offsetLeft - slider.scrollLeft);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });
        index = best;
        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
        updateDots();
      });
    }, { passive:true });

    go(0, 'auto');
  });
});
